angular.module('zc.core')
.factory 'Environment', ($q, Api) ->
  class Environment
    @environment: undefined

    @get: ->
      # environment should be requested just once on reload
      return $q.when(@environment) if @environment
      Api.get "/api/environment", {}
        .then (res) =>
          if res.data.success
            @environment = res.data.environment
          else
            $q.reject res



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/environment.service.coffee